'use client';

import { useContext, useEffect, useMemo, useState } from 'react';
import { QuotesManager } from '@benzinga/quotes-manager';
import { SessionContext } from '@benzinga/session-context';
import { logger } from '@benzinga/logging';

import { logoUrlFromQuote } from './quoteLogo';

export const useTickerLogos = (symbols: Array<string | null | undefined>): Record<string, string> => {
  const session = useContext(SessionContext);
  const [logoBySymbol, setLogoBySymbol] = useState<Record<string, string>>({});
  const uniqueSymbols = useMemo(() => [...new Set(symbols.filter((symbol): symbol is string => Boolean(symbol)))], [symbols]);
  const symbolsKey = uniqueSymbols.join(',');

  useEffect(() => {
    const requestedSymbols = symbolsKey ? symbolsKey.split(',') : [];
    if (requestedSymbols.length === 0) {
      setLogoBySymbol({});
      return;
    }

    let isMounted = true;
    session
      .getManager(QuotesManager)
      .getQuotesLogosMapped(requestedSymbols)
      .then(result => {
        if (!isMounted || result.err || !result.ok) {
          return;
        }
        const next: Record<string, string> = {};
        for (const symbol of requestedSymbols) {
          const logoUrl = logoUrlFromQuote(result.ok[symbol]);
          if (logoUrl) {
            next[symbol] = logoUrl;
          }
        }
        setLogoBySymbol(next);
      })
      .catch(error => {
        logger.error('edge dashboard ticker logos', error);
      });

    return () => {
      isMounted = false;
    };
  }, [session, symbolsKey]);

  return logoBySymbol;
};
